import React, { useState, useEffect } from "react";
import Header from "./Header";
import { mockData } from "../utils/mockData";

const NewsPage = () => {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;

  useEffect(() => {
    // Load mock blog data
    setPosts(mockData.blog.posts);
    setCategories(mockData.blog.categories);
  }, []);

  const filteredPosts = selectedCategory === "all" 
    ? posts 
    : posts.filter(post => post.category === selectedCategory);

  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const currentPosts = filteredPosts.slice(startIndex, startIndex + postsPerPage);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
  };

  return (
    <div className="news-page">
      <Header activeSection="news" />
      
      <main className="news-main">
        <section className="news-hero">
          <div className="container">
            <h1 className="news-title">Latest News & Insights</h1>
            <p className="news-subtitle">
              Stay up to date with the latest trends in design, development, and digital innovation.
            </p>
          </div>
        </section>

        <section className="news-content">
          <div className="container">
            <div className="news-filters">
              <button
                className={`filter-btn ${selectedCategory === "all" ? "active" : ""}`}
                onClick={() => handleCategoryChange("all")}
              >
                All Posts
              </button>
              {categories.map((category) => (
                <button
                  key={category.slug}
                  className={`filter-btn ${selectedCategory === category.slug ? "active" : ""}`}
                  onClick={() => handleCategoryChange(category.slug)}
                >
                  {category.name}
                </button>
              ))}
            </div>

            <div className="posts-grid">
              {currentPosts.map((post) => (
                <article key={post.id} className="post-card">
                  <div className="post-image">
                    <img src={post.image} alt={post.title} />
                    <div className="post-category">{post.categoryName}</div>
                  </div>
                  <div className="post-content">
                    <h2 className="post-title">
                      <a href={`/news/${post.slug}`}>{post.title}</a>
                    </h2>
                    <p className="post-excerpt">{post.excerpt}</p>
                    <div className="post-meta">
                      <span className="post-author">By {post.author}</span>
                      <time className="post-date" dateTime={post.date}>
                        {new Date(post.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </time>
                    </div>
                    <a href={`/news/${post.slug}`} className="post-link">
                      Read More
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="2" fill="none"/>
                      </svg>
                    </a>
                  </div>
                </article>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button
                  className="pagination-btn"
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  aria-label="Go to previous page"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M10 3l-5 5 5 5" stroke="currentColor" strokeWidth="2" fill="none"/>
                  </svg>
                  Previous
                </button>

                <div className="pagination-numbers">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                      key={page}
                      className={`pagination-number ${currentPage === page ? "active" : ""}`}
                      onClick={() => setCurrentPage(page)}
                      aria-label={`Go to page ${page}`}
                      aria-current={currentPage === page ? "page" : undefined}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  className="pagination-btn"
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  aria-label="Go to next page"
                >
                  Next
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="2" fill="none"/>
                  </svg>
                </button>
              </div>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default NewsPage;